import type { WasmWarning } from '@wasm/types';
import styles from './ResultsSummary.module.css';

export interface ResultsSummaryProps {
  success: boolean;
  outputFilename?: string | undefined;
  durationMs?: number | undefined;
  warnings?: WasmWarning[] | undefined;
  errorMessage?: string | undefined;
  children?: React.ReactNode;
}

export function ResultsSummary({
  success,
  outputFilename,
  durationMs,
  warnings = [],
  errorMessage,
  children,
}: ResultsSummaryProps) {
  if (!success && errorMessage) {
    return (
      <div className={`${styles.card} ${styles.errorCard}`}>
        <div className={styles.header}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className={styles.errorIcon}>
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
          <span className={styles.title}>Conversion Failed</span>
        </div>
        <p className={styles.errorMessage}>{errorMessage}</p>
      </div>
    );
  }

  return (
    <div className={`${styles.card} ${styles.successCard}`}>
      <div className={styles.header}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20" className={styles.successIcon}>
          <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        <span className={styles.title}>Conversion Successful</span>
      </div>

      <div className={styles.stats}>
        {outputFilename && (
          <div className={styles.stat}>
            <span className={styles.statLabel}>Output</span>
            <span className={styles.statValue}>{outputFilename}</span>
          </div>
        )}
        {durationMs !== undefined && (
          <div className={styles.stat}>
            <span className={styles.statLabel}>Time</span>
            <span className={styles.statValue}>{durationMs}ms</span>
          </div>
        )}
      </div>

      {warnings.length > 0 && (
        <div className={styles.warnings}>
          {warnings.map((warning, i) => (
            <div key={i} className={styles.warning}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              {warning.message}
            </div>
          ))}
        </div>
      )}

      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
}

export default ResultsSummary;
